<template>
  <div>
    <v-layout row wrap align-center class="pa-3">
      <v-flex xs12 d-flex>
        <div flat color="white" style="display: flex; align-items: center">
          <h2>Rider Base Distance Setting</h2>
          <v-divider class="mx-2" inset vertical></v-divider>
          <create-base-distance
            ref="formDialog"
            province
            fixedPrice
            @onEdit="editBaseDistance($event)"
            @onCreate="addBaseDistance($event)"
            @onResetForm="resetForm()"
            :selectedIndex="selectedIndex"
            :districtList="districtList"
            :isCreating="isCreating"
            :selectedItem="selectedItem"
          />
        </div>
      </v-flex>
    </v-layout>

    <v-card flat>
      <base-distance-table
        class="mt-5"
        @toEdit="
          selectedIndex = $event.index;
          selectedItem = $event.item;
          $refs.formDialog.dialog = true;
        "
        @toChangeStatus="changeStatus($event)"
        :isEditDistance="isEditDistance"
        :isLoading="isLoading"
        :headers="headers"
        :baseDistanceList="baseDistanceList"
        fixedPrice
        isAction
        isDistrict
        isStatus
        @onLoadDistrict="districtList = $event"
      />
    </v-card>
    <v-card
      class="mt-3"
      flat
      style="border: 1.2px solid #c9c9c9; border-radius: 10px"
    >
      <v-card-text>
        <div>
          <table width="100%">
            <tr>
              <th rowspan="2">Main distance</th>
              <th>Time Start</th>
              <th>Distirct</th>
              <th>Store</th>
              <th rowspan="2">
                <v-btn icon @click="toEditMainDistance()"
                  ><v-icon>edit</v-icon></v-btn
                >
              </th>
            </tr>
            <tr>
              <td class="text-xs-center">
                {{
                  moment(mainDistanceItem.distance_time_start).format(
                    "DD/MM/YYYY - HH:mm"
                  )
                }}
              </td>
              <td class="text-xs-center">All</td>
              <td class="text-xs-center">All</td>
            </tr>
          </table>
          <v-divider class="my-3"></v-divider>
          <v-card flat>
            <v-card-text>
              <div
                v-for="(info, index) in mainDistanceItem.distance_text"
                :key="index"
                class="pt-1"
                style="display: flex; align-items: center"
              >
                <v-avatar color="primary" size="30">
                  <span class="black--text">{{ index + 1 }}</span>
                </v-avatar>
                <span class="ml-2"
                  >from {{ info.transport_charge_start + " m." }} to
                  {{ info.transport_charge_end + " m." }} --> Charge
                  {{ info.transport_charge_price + " ฿" }}</span
                >
                <div>
                  <div
                    style="
                      border-radius: 5px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      padding: 0px 10px;
                      background-color: red;
                      color: white;
                    "
                    class="ml-2"
                    v-if="info.is_fixed_price"
                  >
                    Fixed price
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import BaseDistanceTable from "@/components/back-office/BaseDistance/BaseDistanceTable.vue";
import CreateBaseDistance from "@/components/back-office/BaseDistance/CreateBaseDistance.vue";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      isLoading: false,
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
        },
        { text: "Status", align: "center", sortable: false },
        { text: "Time start", align: "center", sortable: false },
        { text: "Time end", align: "center", sortable: false },
        { text: "District", align: "center", sortable: false },
        { text: "Store", align: "center", sortable: false },
        { text: "Action", align: "center", sortable: false },
      ],
      baseDistanceList: [],
      selectedIndex: -1,
      selectedItem: {
        distance_text: [
          {
            transport_charge_start: 0,
            transport_charge_end: 3000,
            transport_charge_price: 10,
            is_fixed_price: false,
          },
        ],
        distance_district: [],
        distance_store: [],
        distance_category: 1,
        distance_status: true,
      },
      isEditDistance: [],
      isCreating: false,
      districtList: [],
      mainDistanceItem: {},
    };
  },
  computed: {},
  methods: {
    ...mapActions({
      updateBaseDistance: "distances/updateBaseDistance",
      createBaseDistance: "distances/createBaseDistance",
    }),
    resetForm() {
      this.selectedIndex = -1;
      this.selectedItem = {
        distance_text: [
          {
            transport_charge_start: 0,
            transport_charge_end: 3000,
            transport_charge_price: 10,
            is_fixed_price: false,
          },
        ],
        distance_district: [],
        distance_store: [],
        distance_category: 1,
        distance_status: true,
      };
    },
    async changeStatus(payload) {
      let form = {
        distance_type: 2,
        province: this.$store.state.backOffice.province,
        distance_id: payload.item.distance_id,
        payload: payload.item,
      };

      let result = await this.updateBaseDistance(form);
      if (result == false) {
        payload.failed();
        return;
      }
      return;
    },
    async addBaseDistance(payload) {
      payload.done();
      this.isCreating = true;

      let form = {
        distance_type: 2,
        province: this.$store.state.backOffice.province,
        payload: payload.form,
      };
      let result = await this.createBaseDistance(form);

      this.isCreating = false;
      if (result == false) return;
      this.setBaseDistanceList(result);
    },
    async editBaseDistance(payload) {
      payload.done();
      let form = {
        distance_type: 2,
        province: this.$store.state.backOffice.province,
        distance_id: this.selectedItem.distance_id,
        payload: payload.form,
      };
      this.isEditDistance.push(this.selectedIndex.distance_id);
      let result = await this.updateBaseDistance(form);
      let index = this.isEditDistance.findIndex(
        (val) => val == this.selectedItem.distance_id
      );
      this.isEditDistance.splice(index, 1);
      if (result == false) return;

      this.setBaseDistanceList(result);
    },
    async getBaseDistance() {
      this.isLoading = true;
      let result = await this.$store.dispatch("distances/fetchBaseDistance", {
        distance_type: 2,
        province: this.$store.state.backOffice.province,
      });
      if (result == false) return;
      this.setBaseDistanceList(result);
      this.isLoading = false;
    },
    toEditMainDistance() {
      this.selectedIndex = -2;
      this.selectedItem = JSON.parse(JSON.stringify(this.mainDistanceItem));
      this.$refs.formDialog.dialog = true;
    },
    setBaseDistanceList(list) {
      let result = list.map((val) => {
        val.distance_district = JSON.parse(val.distance_district);
        val.distance_store = JSON.parse(val.distance_store);
        return val;
      });

      if (result.length > 0) {
        this.mainDistanceItem = result
          .sort((a, b) => a.distance_id - b.distance_id)
          .find((val) => val.distance_category == 1);
      }

      this.baseDistanceList = JSON.parse(JSON.stringify(result));
      let index = this.baseDistanceList.findIndex(
        (val) => val.distance_category == 1
      );
      this.baseDistanceList.splice(index, 1);
      this.baseDistanceList.sort((a, b) => b.distance_id - a.distance_id);
    },
  },
  components: {
    "base-distance-table": BaseDistanceTable,
    "create-base-distance": CreateBaseDistance,
  },
  async created() {
    this.getBaseDistance();
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },

      {
        text: "Set Base Distance",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style lang="scss" scoped></style>
